import React from 'react'
import '../../assets/css/a4.css';
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken, getUserSettings} from '../../storage'
import DebitA4 from './previews/debita4.js'
import {Link } from 'react-router-dom'
import {Loader} from '../../utils/misc'

const A4Portrait = () =>(
  <style>
{".preview-a4,.pharma-a5 {width: 210mm; min-height: 280mm;} @page {margin: 0;size: A4 portrait;min-height: 0;}"}
  </style>
)

const A4Landscape = () =>(
  <style>
{".preview-a4,.pharma-a5 {width: 297mm;min-height: 190mm; } @page {margin: 0;size: A4 landscape;min-height: 0;}"}
  </style>
)

const A5Portrait = () =>(
  <style>
{".preview-a4,.pharma-a5  {width: 148mm; min-height: 190mm;} @page {margin: 0;size: A5 portrait;min-height: 0;}"}
  </style>
)

const A5Landscape = () =>(
  <style>
{".preview-a4,.pharma-a5  {width: 210mm;min-height: 0; } @page {margin: 0;size: A5 landscape;min-height: 0;}"}
  </style>
)

function invoiceFont(size) {
  return <style>
  {".preview-a4,.pharma-a5{font-size: " + size + "px; }"
  +".preview-a4 .company-name {font-size: " + (size+7) + "px; } "
  + " .preview-a4 .table,.pharma-a5 .table {font-size: " + (size-1) + "px; }  "
   +"@page {font-size:" + size + "px;}"
   +"@print { .preview-a4 .table,.pharma-a5 .table  {font-size: " + (size-1) + "px; }"
    +".preview-a4 .company-name {font-size: " + (size+7) + "px; }}"
   }
  </style>
}
export default class PreviewCredit extends React.Component {

  constructor(props){
    super(props)
    this.getCredit = this.getCredit.bind(this)
    this.print = this.print.bind(this)
    this.state = {loading:true, downloading:false}
  }

  componentDidMount(){
    document.title = "Credit " + this.props.match.params.pretn_id
    this.getCredit(this.props.match.params.pretn_id).then((response)=>{
      this.setState({pretn:response.data.pretn,

        company_profile: response.data.company_profile, loading:false})
    })
  }

  print(e) {
    e.preventDefault();
    window.print();
  }


  getCredit(pretn_id) {
    return axios({
      url: '/get_pretn/?serial='+pretn_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }


  render() {

    let settings = getUserSettings()
    let pageSize = <A4Portrait />


    let invoiceFontSize = invoiceFont(settings.invoice_font_size)

    let preview_style

    preview_style = <div>{pageSize}<DebitA4 debit={this.state.pretn} company={this.state.company_profile} /></div>

          let editLink = <Link to={"/debit_notes/edit/"+this.props.match.params.pretn_id} className="btn btn-primary" >Edit</Link>

          let printLink = <Link to="#" className="btn btn-success" onClick={this.print}>Print <span className="hidden-sm">(Ctrl+p)</span></Link>

            if(this.state.loading) {
                return <div><Loader /> </div>
            }
            else {
              return <div>
                    <section className="small">
                      <div className="hidden-print pull-left">
                        <ul className="list-inline">
                          <li>{editLink}</li>

                          <li>{printLink}</li>
                        </ul>
                      </div>
                    </section>
                    {preview_style}
                  </div>
            }
  }
}



// WEBPACK FOOTER //
// ./src/components/debit/previewdebit.js